import axios from 'axios';
import { OPEN_REQUESTS } from 'RestAPIs/endpoints';
import { OpenRequestResponse } from './types';

export const getOpenRequests = ({ costCenters, startDate, endDate }) =>
  axios.get<OpenRequestResponse[]>(OPEN_REQUESTS, {
    params: {
      costCenters,
      startDate,
      endDate
    }
  });
